import { memo } from 'react';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface IProps {
  text?: string;
  active?: boolean;
  onClick?: () => void;
}

const CateSubmenuItem = ({ text = '', active = false, onClick }: IProps) => {
  const cName = classNameBind(['cate-submenu item', active ? 'active' : '']);

  return (
    <S.CateSubmenuItem className={cName}>
      <Button onClick={onClick}>{text}</Button>
    </S.CateSubmenuItem>
  );
};

export default memo(CateSubmenuItem);
